import React, { useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { UserSchema } from "../../schema/UserSchema";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import Select from "../../helpers/FormikHelper/Select";
import userServices from "../../services/user.services";
import { toast } from "react-toastify";
import centerServices from "../../services/center.services";
import { Link } from "react-router-dom";
import { CenterSchema } from "../../schema/CenterSchema";

const initialValues = {
  email: "",
  center_name: "",
  contact_no: "",
  address: "",
  city_id: "",
  state_id: "",
  gst_no: "",
  name: "",
  gender: "male",
  mobile: "",
  user_email: "",
  user_type_id: 2,
  user_address: "",
  center_id: "",
  password: "",
  registration_no: "",
  gst_reg: 'no',
};

const CenterForm = ({
  toggle,
  isAddMode,
  cities,
  states,
  getAllCenters,
  getAllCenterUsers,
  selectedRow,
}) => {
  const [isActiveTab, setIsActivTab] = useState("TabOne");
  const [isActiveGST, setIsActiveGST] =  useState(selectedRow?.gst_reg==='yes'?true:false);
  const savedValues = {
    email: selectedRow?.email,
    center_name: selectedRow?.center_name,
    contact_no: selectedRow?.contact_no,
    address: selectedRow?.address,
    city_id: selectedRow?.city_id,
    state_id: selectedRow?.state_id,
    gst_no: selectedRow?.gst_no,
    gst_reg: selectedRow?.gst_reg,
    registration_no: selectedRow?.registration_no,
  };
  const onSubmit = async (values) => {
    const reqBody = {
      center_name: values.center_name,
      contact_no: values.contact_no,
      email: values.email,
      user_type_id: 2,
      address: values.address,
      state_id: values.state_id,
      city_id: values.city_id,
      gst_no: values.gst_no,
      name: values.fullName,
      gender: values.gender,
      mobile: values.mobile,
      user_email: values.user_email,
      user_type_id: 2,
      user_address: values.user_address,
      center_id: values.center_id,
      password: values.password,
      registration_no: values.registration_no,
      gst_reg: values.gst_reg,
    };
    if (isAddMode === "Add") {
      const result = await centerServices.createCenter(reqBody);
      if (result.data.status === true) {
        // actions.resetForm();
        getAllCenters();
        getAllCenterUsers();
        toggle();
        toast.success("Record added successfully", {
          toastId: "registration_success",
          autoClose: 3000,
        });
      } else {
        toast.error(result.data.message, {
          toastId: "registration_fail",
          autoClose: 3000,
        });
      }
    }
  };
  const onClickTab = (value) => {
    setIsActivTab(value);
  };
  return (
    <React.Fragment>
      <Formik
        initialValues={isAddMode === "Add" ? initialValues : savedValues}
        onSubmit={onSubmit}
        validationSchema={CenterSchema(isActiveGST===true?"ADD_CENTER_WITH_GST":"ADD_CENTER")}
        enableReinitialize
      >
        {({ setFieldValue, values }) => (
          <Form>
            <ModalHeader toggle={toggle}>
              <div className="card-title d-flex align-items-center mb-0">
                <div>
                  <i className="bx bxs-user me-1 font-22 text-primary" />
                </div>
                <h5 className="mb-0 text-primary">
                  {isAddMode === "Add" ? "Add Center" : "Update Center"}
                </h5>
              </div>
            </ModalHeader>
            <ModalBody className="">
              <Col md={12}>
                <>
                  {/* SmartWizard html */}
                  <div className="center-wizard">
                    <ul className="nav">
                      <li
                        className={`nav-item ${
                          isActiveTab === "TabOne" && "active"
                        }`}
                        onClick={() => onClickTab("TabOne")}
                      >
                        <a className="nav-link h6">
                          {" "}
                          <strong>Center Detail </strong>
                        </a>
                      </li>
                      <li
                        className={`nav-item ${
                          isActiveTab === "TabTwo" && "active"
                        }`}
                        onClick={() => onClickTab("TabTwo")}
                      >
                        <a className="nav-link h6">
                          {" "}
                          <strong>Center User Detail</strong>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div
                        id="step-1"
                        className={`tab-pane ${
                          isActiveTab === "TabOne" ? "center_form_tab" : ""
                        }`}
                        role="tabpanel"
                        aria-labelledby="step-1"
                      >
                        <div className="row g-3">
                          <div className="col-md-6 ">
                            <label htmlFor="center_name" className="form-label">
                              Center Name
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="center_name"
                              name="center_name"
                            />
                            <ErrorMessage
                              name="center_name"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-6 ">
                            <label
                              htmlFor="registration_no"
                              className="form-label"
                            >
                              CMHO Registration 
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="registration_no"
                              name="registration_no"
                              // maxLength="15"
                            />
                            <ErrorMessage
                              name="registration_no"
                              component={TextError}
                            />
                          </div>

                          <div className="col-md-2">
                            <label htmlFor="" className=" form-label">
                            is GST registered?
                            </label>
                            <br />

                            <label htmlFor="" className="me-3">
                              Yes
                              <Field
                                type="radio"
                                name="gst_reg"
                                id="yes"
                                value="yes"
                                className="ms-2 form-check-input"
                                onClick={() => setIsActiveGST(true)}
                              />
                            </label>
                            <label htmlFor="female" className="">
                              No
                              <Field
                                type="radio"
                                name="gst_reg"
                                id="no"
                                value="no"
                                className="ms-2 form-check-input"
                                onClick={() => {
                                  setIsActiveGST(false);
                                }}
                              />
                            </label>
                          </div>
                          <div className="col-md-10">
                            {isActiveGST === true ? (
                              <>
                                <label
                                  htmlFor="gst_no"
                                  className="me-5 form-label"
                                >
                                  Enter GST No.
                                </label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  id="gst_no"
                                  name="gst_no"
                                  maxLength={15}
                                />

                                <ErrorMessage
                                  name="gst_no"
                                  component={TextError}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="col-md-6">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <Field
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                            />
                            <ErrorMessage name="email" component={TextError} />
                          </div>
                          <div className="col-md-6 ">
                            <label htmlFor="contact_no" className="form-label">
                              Contact No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="contact_no"
                              name="contact_no"
                              maxLength="10"
                            />
                            <ErrorMessage
                              name="contact_no"
                              component={TextError}
                            />
                          </div>
                          <div className="col-12 ">
                            <label htmlFor="address" className="form-label">
                              Address
                            </label>
                            <Field
                              className="form-control"
                              id="address"
                              // placeholder="Address..."
                              name="address"
                              type="text"
                            />
                            <ErrorMessage
                              name="address"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="state_id" className="form-label">
                              State
                            </label>
                            <Field
                              as="select"
                              className="form-select"
                              id="state_id"
                              name="state_id"
                            >
                              <option disabled value="">
                                Select State
                              </option>
                              {states.map((e, key) => {
                                return (
                                  <option key={key} value={e.state_id}>
                                    {e.state_name}
                                  </option>
                                );
                              })}
                            </Field>
                            <ErrorMessage
                              name="state_id"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="city_id" className="form-label">
                              {" "}
                              City{" "}
                            </label>
                            <Field
                              as="select"
                              className="form-select"
                              id="city_id"
                              name="city_id"
                              // onChange={e => {
                              //     // call the built-in handleBur
                              //     handleBlur(e)
                              //     // and do something about e
                              //     let someValue = e.currentTarget.value
                              //     console.log('someValue', someValue)
                              //     setFieldValue("city", someValue);
                              //     // ...
                              // }}
                            >
                              <option disabled value="">
                                Select city
                              </option>
                              {cities.map((e, key) => {
                                if (e.state_id === values.state_id) {
                                  return (
                                    <option key={key} value={e.city_id}>
                                      {e.city_name}
                                    </option>
                                  );
                                }
                              })}
                            </Field>
                            <ErrorMessage
                              name="city_id"
                              component={TextError}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        id="step-2"
                        className={`tab-pane ${
                          isActiveTab === "TabTwo" ? "center_form_tab" : ""
                        }`}
                        role="tabpanel"
                        aria-labelledby="step-2"
                      >
                        <div className="row g-3">
                          <div className="col-md-6">
                            <label htmlFor="fullName" className="form-label">
                              Full Name
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="fullName"
                              name="fullName"
                            />
                            <ErrorMessage
                              name="fullName"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="mobile" className="form-label">
                              Mobile No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              id="mobile"
                              name="mobile"
                            />
                            <ErrorMessage name="mobile" component={TextError} />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="user_email" className="form-label">
                              Email
                            </label>
                            <Field
                              type="email"
                              className="form-control"
                              id="user_email"
                              name="user_email"
                            />
                            <ErrorMessage
                              name="user_email"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="password" className="form-label">
                              Password
                            </label>
                            <Field
                              type="password"
                              className="form-control"
                              id="password"
                              name="password"
                              disabled={isAddMode === "Add" ? false : true}
                            />
                            <ErrorMessage
                              name="password"
                              component={TextError}
                            />
                          </div>
                          <div className="col-12">
                            <label
                              htmlFor="user_address"
                              className="form-label"
                            >
                              address
                            </label>
                            <Field
                              className="form-control"
                              id="user_address"
                              // placeholder="Address..."
                              name="user_address"
                              type="text"
                            />
                            <ErrorMessage
                              name="user_address"
                              component={TextError}
                            />
                          </div>
                          <div className="col-md-12">
                            <label htmlFor="mobile" className="form-label">
                              Gender
                            </label>
                            <br />
                            <label htmlFor="male" className="me-3">
                              Male
                              <Field
                                type="radio"
                                name="gender"
                                id="male"
                                value="male"
                                className="ms-2 form-check-input"
                              />
                            </label>
                            <label htmlFor="female" className="">
                              Female
                              <Field
                                type="radio"
                                name="gender"
                                id="female"
                                value="female"
                                className="ms-2 form-check-input"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </Col>
            </ModalBody>
            <ModalFooter>
              {isActiveTab === "TabTwo" ? (
                <Link
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onClickTab("TabOne")}
                >
                  Previous
                </Link>
              ) : (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggle}
                >
                  Close
                </button>
              )}
              {isActiveTab === "TabOne" ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => onClickTab("TabTwo")}
                  disabled={
                    values.center_name == "" ||
                    values.contact_no == "" && true
                  }
                >
                  Next
                </button>
              ) : (
                <button type="submit" className="btn btn-primary px-5">
                  {isAddMode === "Add" ? "Save" : "Update"}
                </button>
              )}
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default CenterForm;
